import mitt from 'mitt';

/** Separating the emitter instance from the implementation makes it easier to mock the emitter in unit tests. */
export const emitter = mitt();
